import React from 'react';
import classNameBind from 'classnames/bind';
import { withTranslation } from '../../../Translator';
import styles from './LoadMore.module.css';

const bindClasses = classNameBind.bind(styles);

const LoadMore = ({ onClick, t }) => (
  <div className={bindClasses('wrapper')}>
    <a
      onClick={onClick}
      className={bindClasses('button')}
      tabIndex={0}
      role="button"
      data-ppuc-id="Sidebar.LoadMore"
    >
      {t('ListSidebar.loadMore')}
    </a>
  </div>
);

export default withTranslation('components')(LoadMore);
